<!-- about -->
<template>
  <div class="about">
    <div class="bgBox section1 ">
      <div class="s1_innerBox typeArea">
        <div class="opctBox">
          <div class="p p1">
            SUMMIT is a high-tech enterprise speciali-
          </div>
          <div class="p p1 p2">
            zing in levitation metallurgy technology
          </div>
          <div class="line"></div>
        </div>
      </div>
    </div>
    <div class="bgBox section2 " id="公司简介">
      <div class="s2_innerBox typeArea">
        <div class="bodyBox">
          <div class="top">
            <div class="box1">
              <div class="topTitle leftTop">
                <div class="p1">
                  ABOUT<span> US</span>
                </div>
                <div class="p2"></div>
                <div class="p4">
                  <img src="../../static/images/about/简介.jpg" class="imgBox" alt="">
                  Shenzhen Summit New Materials Co., Ltd. was founded on November 09, 2016, with a registered capital of
                  11 million yuan. Located in Huahan Science and Technology Industrial Park, Pingshan District,
                  Shenzhen, and adjacent to Shenzhen 3D printing Manufacturing Innovation Center, it is an equipment
                  manufacturing enterprise and metal material supply enterprise with levitation metallurgy as its core
                  technology. It is also the top technology enterprise specializing in the development of levitation
                  melting technology in China. The company has more than 12 authorized patents, passed the ISO9001:2015
                  certification, fication, and was recognized as a national high-tech enterprise by Shenzhen Science and
                  Technology Innovation Commission.
                </div>
                <div class="p5">
                  In the field of levitation metallurgy, Summit has reached the international advanced and domestic
                  leading level:
                </div>
                <div class="p5">
                  ★ Strong levitation capacity: the height/diameter ratio of the molten pool hump =2.0~3.0, and the
                  condensation in the smelting process is very small;
                </div>
                <div class="p5">
                  ★ High melting temperature: the highest melting temperature can reach 3600℃, including tungsten,
                  tantalum, molybdenum, niobium and other refractory metals;
                </div>
                <div class="p5">
                  ★ Wide range of specifications: smelting capacity from 50g to 200kg specification series;
                </div>
                <div class="p5">
                  ★ Combination with a variety of modern technologies: centrifugal casting, bottom casting, suction
                  casting, continuous drawing ingot, arc melting, plasma melting, etc.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="blockBox">
          <div class="left">
            <div class="item item1">
              <div class="p1">
                Our Tenet
              </div>
              <div class="p2"></div>
              <div class="p4">Product quality first, customer interests first</div>
            </div>
            <div class="flx">
              <div class="item item2">
                <div class="p1">
                  Our Vision
                </div>
                <div class="p2"></div>
                <div class="p4">To create a leading new material innovation platform</div>
              </div>
              <div class="item item3">
                <div class="p1">
                  Our Core values
                </div>
                <div class="p2"></div>
                <div class="p4">People-oriented, combination of production and research, service first</div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="item item4">
              <div class="p1">
                Our Mission
              </div>
              <div class="p2"></div>
              <div class="p4">Help scientific research, service industry</div>
            </div>
            <div class="item item5">
              <div class="p1">
                Our Culture
              </div>
              <div class="p2"></div>
              <div class="p4">Professional, diligent, pragmatic, grateful</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgBox section3" id="发展历程">
      <div class="sdBox"></div>
      <div class="s3_innerBox typeArea">
        <div class="topTitle leftTop">
          <div class="p1">
            <span>MILESTONES</span>
          </div>
          <div class="p2"></div>
          <div class="img">

          </div>
          <!-- <img src="../../static/images/smeltingEquipment/设备应用.jpg" alt=""> -->
        </div>
        <div class="treeBox">
          <div class="mid">
            <div class="line line1"></div>
            <div class="round left">
              <div class="span ">2022</div>
              <div class="contbox">
                <div class="p1">Positioning material development platform strategy</div>
                <div class="p2">We have established a new strategy, which is to combine industry and academic resources, create an advanced material innovation platform, and strive to enhance the technological innovation and commercial application capabilities of the new material industry</div>
              </div>
            </div>
            <div class="line line2"></div>
            <div class="round right">
              <div class="span ">2020</div>
              <div class="contbox">
                <div class="p1">50kg level melting equipment</div>
                <div class="p2">The smelting capacity of the equipment reaches 50kg per furnace, which realizes the large-scale production of special materials such as aluminum and scandium targets.</div>
              </div>
            </div>
            <div class="line line2"></div>
            <div class="round left">
              <div class="span ">2019</div>
              <div class="contbox">
                <div class="p1">Breaking new melting temperatures</div>
                <div class="p2">The melting temperature has broken through to 3400 ℃, and the smelting of refractory metals such as tungsten, tantalum, rhenium and their alloys has been realized</div>
              </div>
            </div>
            <div class="line line2"></div>
            <div class="round right">
              <div class="span ">2018</div>
              <div class="contbox">
                <div class="p1">20kg level melting equipment</div>
                <div class="p2">Equipment from the melting capacity of 20kg per furnace, with some special materials small batch industrial production scale, to achieve the leap from the laboratory to large-scale production</div>
              </div>
            </div>
            <div class="line line2"></div>
            <div class="round left">
              <div class="span ">2017</div>
              <div class="contbox">
                <div class="p1">5kg level melting equipment</div>
                <div class="p2">Successfully developed 5kg levitation melting equipment, melting temperature reached 2800℃ or more, can melt metal molybdenum and its alloys. In the same year, he received 500,000 yuan of entrepreneurship funding from Shenzhen</div>
              </div>
            </div>
            <div class="line line2"></div>
            <div class="round right">
              <div class="span ">2016</div>
              <div class="contbox">
                <div class="p1">Company establishment</div>
                <div class="p2">The company was established to design, manufacture and develop levitation melting equipment</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgBox section4 " id="荣誉资质">
      <div class="s4_innerBox typeArea">
        <div class="topTitle centerTop">
          <div class="p1">
            OUR<span> HONOR </span>AND<span> QUALIFICATION </span>
          </div>
          <div class="p2"></div>
        </div>
        <div class="selectBox">
          <div class="selInerBox">
            <div class="item" :class="active==1?'active':''" @click="section4Func(1)">
              High-tech enterprise
            </div>
            <div class="item" :class="active==2?'active':''" @click="section4Func(2)">
              Qualification certificate
            </div>
            <div class="item" :class="active==3?'active':''" @click="section4Func(3)">
              Intellectual patent
            </div>
          </div>

        </div>
        <div class="bodyBox bodyBox1" v-if="active==1">
          <img style="width:610px;height:368px" src="../../static/images/about/高企.jpg" alt="">
        </div>
        <div class="bodyBox bodyBox2" v-if="active==2">
          <img style="width:906px;height:640px" src="../../static/images/about/证书.jpg" alt="">
        </div>
      </div>
    </div>
    <div class="bgBox section5" v-if="active==3">
      <div class="innerDiv">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="item in 12" :key="item">
            <img class="pic" :src="'../../static/images/about/专利'+item +'.jpg'" alt="">
          </swiper-slide>
        </swiper>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    name: 'about',
    components: {},
    data() {
      return {
        active: 1,
        swiperOption: {
          //自动播放
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          },
          slidesPerView: 5,
          spaceBetween: 20,
          centeredSlides: true,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        }
      }
    },
    computed: {},
    watch: {},
    created() {
      this.init()
    },
    mounted() {
      if (this.$store.state.pageId) {
        this.$el.querySelector(this.$store.state.pageId).scrollIntoView({
          behavior: 'smooth',
          block: "start"
        })
      } else {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
      this.$store.commit('savePageId', '')
    },
    methods: {
      init() {

      },
      section4Func(data) {
        this.active = data
      }
    },
  }

</script>

<style lang='less' scoped>
  .about {
    min-width: 1200px;
    height: 100%;

    .section1 {
      width: 100%;
      height: 600px;
      background: url('../../static/images/about/banner.jpg') no-repeat;
      background-position: center;

      .s1_innerBox {
        padding-top: 234px;
        text-align: left;

        .opctBox {
          width: 1245px;
          height: 300px;
          // opacity: 0.4;
          background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.1) 2%, rgba(0, 0, 0, 0.4) 20%, rgba(0, 0, 0, 0.4) 80%, rgba(255, 255, 255, 0.1) 98%, rgba(255, 255, 255, 0) 100%);

          .p1 {
            font-size: 60px;
            line-height: 60px;
            padding-top: 50px;
            color: #fefefe;

          } 
          .p2{
            padding-top: 38px;
          }
          .line {
            width: 200px;
            height: 8px;
            margin-top: 42px;
            background-color: #c30000;
          }
        }

      }
    }

    .s2_innerBox {
      height: 100%;
      padding-top: 261px;

      .bodyBox {
        width: 1190px;
        height: 588px;
        padding: 0 0 20px 35px;
        background-color: transparent;
        border: solid 2px #c30000;
        z-index: 99;
        position: relative;

        .top {
          display: flex;
          height: 460px;

          .box1 {
            flex: 1;

            .topTitle {
              .p1 {
                margin-top: 35px;

                p {
                  margin-top: 20px;
                }
              }

              .p3 {
                margin-bottom: 50px;
              }

              .p4,
              .p5 {
                font-size: 16px;
                line-height: 28px;
                color: #545454;
                // text-indent: 2em;
                padding-right: 10px;
                font-weight: 400;
              }
            }
          }

          .imgBox {
            width: 622px;
            height: 408px;
            background-color: #ffffff;
            box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.35);
            // position: absolute;
            // top: -53px;
            // right: -53px;f
            float: right;
            margin-top: -215px;
            margin-right: -63px
          }

        }


      }
      .blockBox {
          width: 510px;
          width: 100%;
          margin-top: 55px;
          display: flex;

          .item {
            background-color: #fbfbfb;
            display: flex;
            flex-direction: column;
            align-items: center;
            height: 250px;
            border: 2px solid #fff;

            .p1 {
              font-size: 24px;
              line-height: 24px;
              color: #555555;
              margin-top: 90px;
              transition: all 0.3s;
            }

            .p2 {
              width: 50px;
              height: 4px;
              background-color: #c30000;
              margin: 20px 0;
            }

            .p3 {
              font-size: 16px;
              line-height: 16px;
              color: #555555;
              font-weight: 400;
            }

            .p4 {
              font-size: 16px;
              line-height: 28px;
              color: #555555;
              font-weight: 400;
              margin-top: 33px;
              visibility: hidden;
            }
          }

          .item:hover {
            border: 2px solid #c30000;
            .p1 {
              margin-top: 60px;
            }

            .p4 {
              visibility: initial;
            }
          }

          .left {
            width: 795px;
            margin-right: 10px;
            height: 100%;
            display: flex;
            flex-wrap: wrap;

            .item1 {
              width: 100%;

            }

            .flx {
              margin-top: 10px;
              display: flex;
              width: 100%;
              flex-direction: row;
              justify-content: space-between;
            }

            .item2 {
              width: 392px;
            }

            .item3 {
              width: 392px;
            }
          }

          .right {
            width: 392px;
            height: 100%;

            .item4 {
              margin-bottom: 10px;
            }
          }
        }
    }

    .section3 {
      // margin-top: 300px;
      width: 100%;
      height: 1400px;
      background-color: #fbfbfb;

      .sdBox {
        height: 300px;
        width: 100%;
        background-color: #ffffff;
      }

      .s3_innerBox {
        position: relative;
        height: 100%;

        .topTitle {
          margin-bottom: 220px;

          .p1 {
            margin-top: -40px;
          }

          .img {
            position: absolute;
            top: -64px;
            left: 500px;
            height: 200px;
            width: calc(~"100vw/2 + 90px");
            background: url('../../static/images/about/历程.jpg') no-repeat;
            background-position: left;
          }
        }

        .treeBox {
          height: 810px;
          display: flex;
          justify-content: center;

          .mid {
            display: flex;
            flex-direction: column;
            align-items: center;

            .round {
              width: 12px;
              height: 12px;
              background-color: #adadad;
              border-radius: 50%;
              margin: 4px 0;
              position: relative;

              .span {
                font-size: 20px;
                color: #c30000;
                position: absolute;
                top: -9px;
              }

              .contbox {
                width: 536px;
                // height: 131px;
                background-color: #ffffff;
                position: absolute;
                top: -9px;
                padding: 0 12px 12px;

                .p1 {
                  font-size: 18px;
                  line-height: 18px;
                  margin-top: 5px;
                  color: #333333;
                }

                .p2 {
                  margin-top: 10px;
                  font-size: 16px;
                  line-height: 28px;
                  color: #666666;
                  text-align: left;
                }
              }
            }

            .left.round {
              .span {
                left: -55px;
              }

              .contbox {
                left: -600px;

                .p1 {
                  text-align: right;
                }
              }
            }

            .right.round {
              .span {
                right: -55px;

              }

              .contbox {
                right: -600px;

                .p1 {
                  text-align: left;
                }
              }
            }

            .line {
              width: 2px;
              background-color: #adadad;
            }

            .line1 {
              height: 50px;
            }

            .line2 {
              height: 100px;
            }
          }
        }
      }
    }

    .section4 {
      width: 100%;
      // height: 525px;

      // margin-bottom: 180px;
      .s4_innerBox {
        height: 100%;

        .topTitle {
          .p1 {
            margin-top: 250px;
          }
        }

        .selectBox {
          width: 100%;
          height: 50px;
          display: flex;
          justify-content: center;
          margin-top: 71px;

          .selInerBox {
            width: 800px;
            height: 50px;
            display: flex;
            justify-content: space-between;

            .item {
              width: 240px;
              height: 50px;
              line-height: 48px;
              border: solid 1px #c30000;
              font-size: 20px;
              font-weight: 400;
              text-align: center;
              color: #555555;
              cursor: pointer;
            }

            .item.active {
              background-color: #c30000;
              color: #fffefe;
            }
          }

        }

        .bodyBox {
          width: 100%;
          height: 660px;
          display: flex;
          justify-content: center;
          margin-top: 80px;
          margin-bottom: 200px;

          img {
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.35);
            border: solid 2px #c30000;
          }

        }
      }
    }

    .section5 {
      height: 660px;
      width: 1200px;
      margin: 0 auto;
      margin-top: 30px;
      margin-bottom: 200px;
      position: relative;

      .innerDiv {
        width: 1900px;
        height: 660px;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);

        .swiper-container {
          height: 100%;
          display: flex;
          justify-content: center;

          .swiper-slide {
            text-align: center;
            font-size: 18px;
            background: #fff;

            /* Center slide text vertically */
            display: -webkit-box;
            display: -ms-flexbox;
            display: -webkit-flex;
            display: flex;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            -webkit-justify-content: center;
            justify-content: center;
            -webkit-box-align: center;
            -ms-flex-align: center;
            -webkit-align-items: center;
            align-items: flex-end;
            transition: all 300ms;

            // width: 280px;
            .pic {
              box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.35);
              border: solid 2px #c30000;
              transition: all 300ms;
              width: 280px !important;
              // scale: (0.6);
            }
          }

          .swiper-slide.swiper-slide-prev,
          .swiper-slide.swiper-slide-next {

            // width: 354px!important;
            .pic {
              width: 330px !important;
              // scale: (0.8);
            }
          }

          .swiper-slide-active,
          .swiper-slide-duplicate-active {

            // width: 450px!important;
            // scale: (1);
            .pic {
              width: 400px !important;
              // scale: (1);
            }
          }
        }
      }

    }
  }

</style>



// WEBPACK FOOTER //
// src/views/aboutEn.vue